import axios from 'axios'

const axiosInstance = axios.create({})

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401 ||  error.response.status === 403)) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');

            location.reload();
        }
        return Promise.reject(error)
    },
)

export default axiosInstance